var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-container"},[_c('div',{ref:"toolbar",staticClass:"toolbar"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.sendGoHomeEmail}},[_vm._v(" 域名切换邮件发送 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }